<template>
  <base-container :isLoading="isLoading">
    <div class="artisan-container">
    <h2 class="artisan-center">绑定就诊卡</h2>
     <van-cell-group style="margin-top:7px;">
      <van-field v-model="info.cardNo" placeholder="请输入就诊卡号" label="就诊卡号">
      </van-field>
      <van-field v-model="info.patientName" placeholder="请输入患者姓名" label="患者姓名"/>
    </van-cell-group>
      <van-button class="artisan-btn" round type="info" block @click="bind">绑定就诊卡</van-button>
    </div>
  </base-container>
</template>

<script>
import { Dialog, Toast } from "vant";
import { BindMedicalCard } from "@/api/customer";
export default {
  data() {
    return {
      isLoading: false,
      info: {
          cardNo:"",
          patientName:""
      },
    };
  },
  methods: {
    bind() {
      if (this.info.cardNo&&this.info.patientName) {
        Dialog.confirm({
          title: "提示",
          message: "确认绑定就诊卡？",
        }).then(() => {
          this.isLoading = true;
          BindMedicalCard(this.info)
            .then(() => {
              this.isLoading = false;
              Toast.success("绑定就诊卡成功！");
            })
            .catch(() => {
              this.isLoading = false;
              Toast.fail("绑定就诊卡失败！");
            });
        });
      } else {
        Toast.fail("请填写就诊卡好及姓名！");
      }
    },
  },
};
</script>

<style>
</style>